export default "__VITE_ASSET__CBzNcVgR__"